import { PlayIcon } from '@heroicons/react/outline';
import React from 'react'
import { useRecoilValue } from 'recoil';
import { contentDetail } from '../../recoil/content';

const VideoLinkList = () => {
  const content = useRecoilValue(contentDetail);

  const loadLinks = () => {
    if (content.videos.length === 0) {
      return <div className="italic text-slate-500">Tidak ada video.</div>;
    }
    return (
      <div className="flex flex-col gap-3">
          {
              content.videos.map((item, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-slate-100">
                      <a href={item} target="_blank" rel="noreferrer" className="flex-1 cursor-pointer overflow-clip hover:text-blue-600">{item}</a>
                  </div>
              ))
          }
      </div>
    );
  };

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="videos" className="text-sm">Link Video</label>
        <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <PlayIcon className="w-6 h-6" />
            <div className="flex flex-col flex-1 gap-3">
                {loadLinks()}
            </div>
        </div>
    </div>
  )
}

export default VideoLinkList